module.exports = __webpack_public_path__ + "img/specific_users_gray.8bf69473.svg";